import * as Yup from 'yup';

export const validationSchemaFormMobi = Yup.object({
  phone: Yup.string()
    .required('Поле обязательно для заполнения')
    .length(17, 'Невалидный номер телефона'),
});
